import React from 'react';
import './LoadingSpinner.css';

/**
 * Universal LoadingSpinner Component
 * 
 * Props:
 * - message: string (default: 'माहिती लोड होत आहे...')
 * - subMessage: string (optional)
 * - size: 'sm' | 'md' | 'lg' (default: 'md')
 * - tone: 'blue' | 'orange' | 'green' | 'white' (default: 'blue')
 * - fullPage: boolean (centers in available view height)
 * - inline: boolean (compact horizontal layout)
 * - style: object (custom inline styles)
 */
export default function LoadingSpinner({
  message = 'माहिती लोड होत आहे...',
  subMessage,
  size = 'md',
  tone = 'blue',
  fullPage = false,
  inline = false,
  className = '',
  style = {},
}) {
  const wrapClasses = [
    'loading-spinner-wrap',
    fullPage ? 'full-page' : '',
    inline ? 'inline' : '',
    className,
  ].filter(Boolean).join(' ');

  const ringClasses = [
    'loading-spinner-ring',
    `size-${size}`,
    `tone-${tone}`,
  ].filter(Boolean).join(' ');

  return (
    <div className={wrapClasses} style={style} role="status" aria-live="polite">
      <div className={ringClasses} aria-hidden="true" />
      {message && <p className="loading-spinner-text">{message}</p>}
      {subMessage && <p className="loading-spinner-subtext">{subMessage}</p>}
    </div>
  );
}

/**
 * Convenience TableRow for rendered <tbody> elements
 * Usage: <LoadingSpinner.TableRow colSpan={8} message="..." />
 */
LoadingSpinner.TableRow = function LoadingSpinnerTableRow({
  colSpan = 1,
  message = 'माहिती लोड होत आहे...',
  subMessage = 'कृपया थोडा वेळ प्रतीक्षा करा...',
  size = 'md',
  tone = 'blue',
}) {
  return (
    <tr>
      <td colSpan={colSpan} className="loading-spinner-table-cell">
        <LoadingSpinner
          message={message}
          subMessage={subMessage}
          size={size}
          tone={tone}
        />
      </td>
    </tr>
  );
};
